export { default } from "./TabsLoadMore";
